import React, { useState } from "react";
import { Descriptions } from "antd";
import { hasCheckedDeliverable, convertSDTM } from "../data-upload/utils";

interface DeliverablesReviewProps {
  initialDeliverables: any;
}

const DeliverablesReview: React.FC<DeliverablesReviewProps> = ({
  initialDeliverables,
}) => {
  const [formData] = useState<any>(initialDeliverables);
  if (Array.isArray(formData?.SDTMDeliverables)) {
    formData.SDTMDeliverables = convertSDTM(formData.SDTMDeliverables);
  }
  const checkedDeliverable = hasCheckedDeliverable(formData?.SDTMDeliverables);

  const items = [
    {
      label:
        <div>
          <span style={{ color: 'black' }}>Does the data contain any PHI?</span>
            <br/>
          <span>If yes,specify how PHI data are masked,de-identified or reached.</span>
        </div>,
      children: (
        <div>
          {formData?.protectionHealthData.comment !== undefined
            ? `${formData?.protectionHealthData.value}, ${formData?.protectionHealthData.comment}`
            : formData?.protectionHealthData.value}
        </div>
      ),
    },
    {
      label:
        <div>
          <span style={{ color: 'black' }}>Does the data contain any unblinding/unmasking components?</span>
            <br/>
          <span>If yes,specify.</span>
        </div>,
      children: (
        <div>
          {formData?.unblindingComponents.comment !== undefined
            ? `${formData?.unblindingComponents.value}, ${formData?.unblindingComponents.comment}`
            : formData?.unblindingComponents.value}
        </div>
      ),
    },
  ];

  return (
    <div style={{ backgroundColor: "white" }}>
      {checkedDeliverable && (
        <Descriptions
          title=""
          bordered
          column={1}
        >
          {(Object.entries(formData.SDTMDeliverables) as [string, any][])
            .filter(([_, value]) => value.checked)
            .map(([key, value]) => (
              <Descriptions.Item key={value.comment} label={key} style={{ color: "black", padding: "8px 16px" }} >
                {value.comment}
              </Descriptions.Item>
            ))}
        </Descriptions>
      )}
      <Descriptions
        size="small"
        bordered
        column={1}
        items={items}
        title=""
      />
    </div>
  );
};

export default DeliverablesReview;
